import { CommonNotificationSaveError, CommonNotificationSaveSuccessFully } from '@shares/CommonNotification';
import { IconPersonShield, IconWarningShield } from '@shares/DMPIcon';
import {
  Avatar,
  Button,
  Col,
  Form,
  Icon,
  Input,
  Layout,
  Menu,
  Row,
  Spin,
  Tabs,
  Typography,
  notification
} from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import _ from 'lodash';
import { UISetting } from 'o2o_layout/lib/common/model';
import React from 'react';
import CommonTypeProps from '../../../common/CommonTypeProps';
import { BIGDATA_CONSTANT } from '../../../common/constant';
import { getCurrentURL, getPrimaryColor } from '../../../common/helper';
import { LinkO2O } from '../../../common/LinkO2O';
import DashboardPageLayoutV2 from '../../../layout/dashboard/DashboardPageLayoutV2';
import DownloadAppStore from '../../../static/image/DownloadAppStore.png';
import DownloadGooglePlay from '../../../static/image/DownloadGooglePlay.png';
import { ModalConfirm2FA } from '../../login/components/modal/ModalConfirm2FA';
import { GetCsrfToken, TResponseGetCsrfToken } from '@shares/hooks';

interface Props extends CommonTypeProps {
  enable2Fa: any;
  verifyEnable2Fa: any;
  verifyDisable2Fa: any;
  uiSetting: UISetting;
}

type TypeQR = {
  qrcode: string;
  secretKeys: string;
};

interface PropsQR extends FormComponentProps {
  qr: TypeQR;
  loading: boolean;
  status: boolean | undefined;
  submit: any;
}

const QRComponent = (props: PropsQR) => {
  const { loading, qr } = props;
  const { getFieldDecorator } = props.form;

  return (
    <Spin spinning={loading}>
      <Row type='flex' gutter={[20, 20]}>
        <Col xs='24'>
          <Avatar shape='square' size={300} src={qr.qrcode ? `data:image/png;base64,${qr.qrcode}` : ''} />
          <p>Scan QR code from your application</p>

          <Form layout='inline' onSubmit={props.submit}>
            <Form.Item label=''>
              {getFieldDecorator('code', {
                rules: [
                  {
                    required: true,
                    message: 'Please Scan QR code from your application',
                  },
                ],
              })(<Input style={{ width: 300 }} placeholder='Enter Code' />)}
            </Form.Item>
            <Form.Item label=''>
              <Button
                onClick={(e: any) => {
                  props.submit(e, props.form);
                }}
                type='primary'
              >
                Verify
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Spin>
  );
};

const QRComponentForm = Form.create<PropsQR>()(QRComponent);

export class TwoFaComponentV2 extends React.Component<Props, any> {
  state = {
    enableToTp: false,
    qr: {
      qrcode: '',
      secretKeys: '',
    } as TypeQR,
    loadingQr: false,
    showModal2FA: false
  };

  timer: any;

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  componentDidMount = () => {
    this.setState({
      enableToTp: this.props.user.totpEnabled,
    });
    this.props.updateMetaTitle({ title: BIGDATA_CONSTANT.trackTitle.TwoFa });
    this.timer = setTimeout(() => {
      this.props.updateMeta({
        name: BIGDATA_CONSTANT.trackTitle.TwoFa,
        title: BIGDATA_CONSTANT.trackTitle.TwoFa,
        app: 'ACCOUNT',
        url: getCurrentURL(this.props.location),
      });
      clearTimeout(this.timer);
    }, 5000);
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.user.totpEnabled !== this.props.user.totpEnabled) {
      this.setState({
        enableToTp: this.props.user.totpEnabled,
      });
    }
  }

  submit = (e: any, form: any) => {
    e.preventDefault();
    form.validateFields(async (err: any, values: any) => {
      if (err) {
        return;
      }

      this.props.setGlobalLoading(true);
      const csrfRes: TResponseGetCsrfToken = await this.props.commonActionFromDALV2(GetCsrfToken);
      const csrfToken = csrfRes.csrfToken;

      this.props
        .verifyEnable2Fa(values.code, this.state.qr.secretKeys, csrfToken)
        .then((e: any) => {
          if (e?.success) {
            CommonNotificationSaveSuccessFully(_.get(e, 'result', undefined));

            setTimeout(() => {
              window.location.reload();
            }, 700);
          } else {
            CommonNotificationSaveError(_.get(e, 'message', 'Invalid key'));
          }
          // notification.success({
          //   message: BIGDATA_CONSTANT.message.default.title.success,
          //   description: e ? e : 'Invalid key',
          //   icon: <Icon type='check-circle' style={{ color: getPrimaryColor(this.props.uiSetting) }} />,
          // });
        })
        .catch(() => {
          notification.error({
            message: BIGDATA_CONSTANT.message.default.title.error,
            description: 'Invalid key',
          });
        })
        .finally(() => {
          this.props.setGlobalLoading(false);
        });
    });
  };

  disable = async (otp?: string, token?: string) => {
    this.props.setGlobalLoading(true);
    try {
      const res = await this.props.verifyDisable2Fa(otp, token)
      this.props.setGlobalLoading(false);
      if (res.success) {
        notification.success({
          message: BIGDATA_CONSTANT.message.default.title.success,
          description: res.message || 'Invalid key',
          icon: <Icon type='check-circle' style={{ color: getPrimaryColor(this.props.uiSetting) }} />,
        });
        setTimeout(() => {
          window.location.reload();
        }, 700);
      } else {
        notification.error({
          message: BIGDATA_CONSTANT.message.default.title.error,
          description: res.message || 'Invalid key',
        });
      }
    } catch (error) {
      this.props.setGlobalLoading(false);
      notification.error({
        message: BIGDATA_CONSTANT.message.default.title.error,
        description: 'Invalid key',
      });
    }
  };

  formRef: any;

  enable2faSwitch = (ev: boolean) => {
    if (ev == false) {
      this.setState({
        showModal2FA: true
      })
    } else {
      this.setState(
        {
          loadingQr: true,
        },
        () => {
          this.props.enable2Fa().then((e: any) => {
            this.setState({
              qr: Object.assign(this.state.qr, e),
              loadingQr: false,
              enableToTp: ev,
            });
          });
        }
      );
    }
  };

  renderModalConfirm2FA() {
    return <ModalConfirm2FA
      okLabel='Disable 2FA'
      hideModal={() => {
        this.setState({
          showModal2FA: false
        })
      }}
      loading={this.props.ui.isLoading}
      okModal={(e: any, form: any) => {
        if (e) e.preventDefault();
        form.validateFields(async (err: any, values: any) => {
          if (err) {
            return;
          }
          this.props.setGlobalLoading(true);
          const csrfRes: TResponseGetCsrfToken = await this.props.commonActionFromDALV2(GetCsrfToken);
          const csrfToken = csrfRes.csrfToken;

          this.disable(values.code, csrfToken)
        });
      }}
      visible={this.state.showModal2FA}
    />
  }

  renderContentLayout = (version?: string) => {
    return (
      <>
        {version === 'v2' && (
          <Tabs
            defaultActiveKey='security'
            onChange={(key: string) => {
              if (key === 'my-profile') this.props.history.push({ pathname: '/my-account-info' });
              if (key === 'security') this.props.history.push({ pathname: '/security/2fa-security' });
              if (key === 'activity') this.props.history.push({ pathname: '/activity/invitation' });
            }}
          >
            <Tabs.TabPane tab='My Profile' key='my-profile' />
            <Tabs.TabPane tab='Security' key='security' />
            <Tabs.TabPane tab='Activity' key='activity' />
          </Tabs>
        )}
        <Layout>
          <Layout.Sider
            width={200}
            style={{ background: '#fff' }}
            className={version === 'v2' ? 'main-menu-v3 menu-connection' : ''}
          >
            <Menu mode='inline' defaultSelectedKeys={['sercurity']} style={{ height: '100%' }}>
              <Menu.Item key='sercurity'>
                <LinkO2O {...this.props} to={{ pathname: '/security/2fa-security' }}>
                  Two-Factor Auth
                </LinkO2O>
              </Menu.Item>
              <Menu.Item key='change-password'>
                <LinkO2O {...this.props} to={{ pathname: '/security/change-password' }}>
                  Change Password
                </LinkO2O>
              </Menu.Item>
              <Menu.Item key='api'>
                <LinkO2O {...this.props} to={{ pathname: '/security/my-account-api' }}>
                  API Account
                </LinkO2O>
              </Menu.Item>
              <Menu.Item key='tokens'>
                <LinkO2O {...this.props} to={{ pathname: '/security/my-account-tokens' }}>
                  Token
                </LinkO2O>
              </Menu.Item>
            </Menu>
          </Layout.Sider>
          <Layout.Content style={{ overflow: 'hidden' }} className='pl30 pt10'>
            <Row gutter={[35, 35]}>
              <Col xs={24}>
                <Row gutter={[10, 10]}>
                  <Col xs={24}>
                    <Typography.Title level={4} className='mb0'>
                      Protect Your Account
                    </Typography.Title>
                    <Typography.Text
                      className='fs16'
                      style={{
                        color: '#87888C',
                      }}
                    >
                      with Two-Factor Authentication (2FA)
                    </Typography.Text>
                  </Col>
                  <Col xs={24} xl={15}>
                    <Typography.Text>
                      Enable two-factor authentication to add an extra layer of security to your account.
                      <br />
                      With 2FA, you'll need to enter a verification code generated by the{' '}
                      <span
                        style={{
                          fontWeight: 700,
                        }}
                      >
                        Google Authenticator
                      </span>{' '}
                      app in addition to your username and password when logging in.
                    </Typography.Text>
                  </Col>
                </Row>
              </Col>

              <Col xs={24}>
                <Row gutter={[10, 10]}>
                  <Col xs={24}>
                    {this.props.user.totpEnabled != this.state.enableToTp ? (
                      <Button
                        type='default'
                        onClick={() => {
                          this.setState({
                            qr: {
                              qrcode: '',
                              secretKeys: '',
                            },
                            loadingQr: false,
                            enableToTp: this.props.user.totpEnabled,
                          });
                        }}
                      >
                        Cancel Two-factor Authentication
                      </Button>
                    ) : (
                      <Button.Group
                        style={{
                          borderRadius: 999,
                          overflow: 'hidden',
                          background: '#efefef',
                        }}
                      >
                        <Button
                          type={this.props.user.totpEnabled ? 'default' : 'primary'}
                          style={{
                            ...(!this.props.user.totpEnabled && {
                              cursor: 'default',
                              borderRadius: 999,
                            }),
                            ...(this.props.user.totpEnabled && {
                              background: 'transparent',
                              borderColor: 'transparent',
                            }),
                            height: 'fit-content',
                            padding: '7.5px 15px',
                          }}
                          onClick={() => {
                            if (this.props.user.totpEnabled) {
                              this.enable2faSwitch(false);
                            }
                          }}
                        >
                          <Icon
                            style={{
                              verticalAlign: 'middle',
                            }}
                            component={IconWarningShield}
                          />
                          DISABLE
                        </Button>
                        <Button
                          type={!this.props.user.totpEnabled ? 'default' : 'primary'}
                          style={{
                            ...(this.props.user.totpEnabled && {
                              cursor: 'default',
                              borderRadius: 999,
                            }),
                            ...(!this.props.user.totpEnabled && {
                              background: 'transparent',
                              borderColor: 'transparent',
                            }),
                            height: 'fit-content',
                            padding: '7.5px 15px',
                          }}
                          onClick={() => {
                            if (!this.props.user.totpEnabled) {
                              this.enable2faSwitch(true);
                            }
                          }}
                        >
                          <Icon
                            style={{
                              verticalAlign: 'middle',
                            }}
                            component={IconPersonShield}
                          />
                          ENABLE
                        </Button>
                      </Button.Group>
                    )}
                  </Col>

                  {this.state.qr.qrcode && (
                    <Col xs={24}>
                      <QRComponentForm
                        submit={this.submit}
                        loading={this.state.loadingQr}
                        qr={this.state.qr}
                        status={this.props.user.totpEnabled}
                        wrappedComponentRef={(form: any) => {
                          this.formRef = form;
                        }}
                      />
                    </Col>
                  )}
                </Row>
              </Col>

              <Col xs={24}>
                <Typography.Text>Download Google Authenticator</Typography.Text>
                <div className='mt5'>
                  <a target='_blank' href='https://apps.apple.com/us/app/google-authenticator/id388497605'>
                    <img src={DownloadAppStore} alt='Download App Store' />
                  </a>
                  <a
                    target='_blank'
                    href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
                  >
                    <img src={DownloadGooglePlay} alt='Download Google Play' />
                  </a>
                </div>
              </Col>

              {this.renderModalConfirm2FA()}
            </Row>
          </Layout.Content>
        </Layout>
      </>
    );
  };

  render() {
    return (
      <DashboardPageLayoutV2
        props={this.props}
        selectedLeftNavStandard='my-security'
        selectedSubMenuStandard='my-security'
        selectedLeftNavModern='my-info'
        selectedSubMenuModern='my-info'
        breadcrumbItemsStandard={[
          { title: 'Home', path: '/' },
          { title: 'Security', path: '/security/2fa-security' },
          { title: '2FA-TOTP' },
        ]}
        breadcrumbItemsModern={[
          { title: 'Account', path: '/' },
          { title: 'Profile', path: '/security/2fa-security' },
          { title: 'Security' },
        ]}
        pageTitle='Profile'
        renderContentLayout={this.renderContentLayout}
        metaTitle={this.props.ui.meta.title}
        pageTitleIcon={
          <Icon
            component={() => (
              <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M2.46644 16.3333H13.5335C14.8691 16.3333 15.5 15.9188 15.5 15.0228C15.5 12.7695 12.6476 9.53332 7.99663 9.53332C3.35234 9.53332 0.5 12.7695 0.5 15.0228C0.5 15.9188 1.13087 16.3333 2.46644 16.3333ZM2.13758 15.2167C1.80873 15.2167 1.68792 15.1298 1.68792 14.8891C1.68792 13.3311 3.96308 10.6566 7.99663 10.6566C12.0369 10.6566 14.3121 13.3311 14.3121 14.8891C14.3121 15.1298 14.1913 15.2167 13.8624 15.2167H2.13758ZM8.01003 8.39661C10.0436 8.39661 11.6812 6.61134 11.6812 4.39816C11.6812 2.22508 10.0436 0.5 8.01003 0.5C5.98322 0.5 4.33221 2.25183 4.33221 4.41153C4.33221 6.61803 5.9765 8.39661 8.01003 8.39661ZM8.01003 7.27998C6.64764 7.27998 5.52013 6.02295 5.52013 4.41153C5.52013 2.84691 6.64093 1.61662 8.01003 1.61662C9.37917 1.61662 10.4933 2.82686 10.4933 4.39816C10.4933 6.00958 9.3725 7.27998 8.01003 7.27998Z'
                  fill='currentColor'
                />
              </svg>
            )}
          />
        }
      />
    );
  }
}
